import React from 'react';
import Error404 from './404';
import Error500 from './500';
import ErrorNotFound from './not-found';
import ErrorUser from './user-error';
import logo_header from '@src/assets/img/logo_header.png';

const ErrorPage = (props) => {
  const errorType = props.errortype || '404';

  return (
    <div className="select-text">
      <img className='h-24px ml-36px mt-24px' src={logo_header} alt="" />
      { errorType == '404' && <Error404 /> }
      { errorType == '502' && <Error500 /> }
      { errorType == 'notFound' && <ErrorNotFound /> }
      { errorType == 'userError' && <ErrorUser /> }
    </div>
  );
}

export default ErrorPage;